export const SAVE_ALL_LOCATIONS = 'SAVE_ALL_LOCATIONS'